import { Center, Flex, Spinner, TableContainer } from "@chakra-ui/react";
import React from "react";
import { ExecutionData } from "src/rest/hedgeFarm";
import { ThemeColor } from "src/theme/palette";
import { Card, CardProps, Notice } from "src/uikit";
import { Heading } from "src/uikit/typography";
import { Maybe } from "true-myth";
import { PerformanceHistoryTable } from "./components/PerformanceHistoryTable";

interface Props extends CardProps {
    data: Maybe<ExecutionData>;
}

export const Execution = ({ data, ...props }: Props) => (
    <Card {...props}>
        <Flex direction={"column"}>
            <Heading as={"h4"} color={ThemeColor.ACTION_PRIMARY}>
                Strategy Allocation
            </Heading>
            {data
                .map(({ positions }) => (
                    <>
                        {positions.length > 0 ? (
                            <TableContainer mt={2}>
                                <PerformanceHistoryTable variant={"info"} data={positions} />
                            </TableContainer>
                        ) : (
                            <Notice color={ThemeColor.ACTION_PRIMARY} icon={"generic.info"} mt={4}>
                                No positions opened yet.
                            </Notice>
                        )}
                    </>
                ))
                .unwrapOr(
                    <Center h={"57.6rem"}>
                        <Spinner />
                    </Center>,
                )}
        </Flex>
    </Card>
);
